module.exports = __webpack_public_path__ + "img/investec-logo.0480b0be.png";